import React from 'react';
import MainCard from '../Common/MainCard';
import SettingsTab from './Settings/SettingsTab';
import './Settings/TeamSettings.css';

/**
 * The team's settings on a page of their own, for the resource's edit route.
 *
 * The same form the team settings tab shows — a team has one set of settings,
 * so there is one form for them and two ways to reach it.
 */
const TeamEdit = (props: any) => (
    <div className="netorca-team netorca-frame">
        <MainCard className="tm-panel">
            <SettingsTab teamId={props.id} />
        </MainCard>
    </div>
);

export default TeamEdit;
